import { render, staticRenderFns } from "./SpacerList.vue?vue&type=template&id=1eed1d51&"
import script from "./SpacerList.vue?vue&type=script&lang=js&"
export * from "./SpacerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports